import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Whatsapp, Envelope } from 'react-bootstrap-icons';

interface ContactCourseModalProps {
  show: boolean;
  onHide: () => void;
  courseTitle: string;
}

const ContactCourseModal: React.FC<ContactCourseModalProps> = ({
  show,
  onHide,
  courseTitle,
}) => {
  const message = `Sono interessato al corso ${courseTitle}`;

  const handleWhatsApp = () => {
    const encoded = encodeURIComponent(message);
    window.open(
      `https://wa.me/3757481380?text=${encoded}`,
      '_blank',
      'noopener,noreferrer'
    );
    onHide();
  };

  const handleEmail = () => {
    const subject = encodeURIComponent('Info corsi in uscita');
    const body = encodeURIComponent(message);
    window.location.href = `mailto:info@benessereposturale.it?subject=${subject}&body=${body}`;
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton className="bg-body-tertiary border-body">
        <Modal.Title className="fw-bold text-body-emphasis fs-6">
          Contattami per <em>{courseTitle}</em>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-body p-4">
        <p className="text-body mb-4">
          Scegli come vuoi contattarmi, ti risponderò appena possibile.
        </p>
        <div className="d-grid gap-3">
          <Button
            variant="success"
            size="lg"
            onClick={handleWhatsApp}
            className="fw-semibold"
          >
            <Whatsapp className="contact-icon me-2" />
            Scrivimi su WhatsApp
          </Button>
          <Button
            variant="outline-secondary"
            size="lg"
            onClick={handleEmail}
            className="fw-semibold"
          >
            <Envelope className="contact-icon me-2" />
            Inviami una mail
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContactCourseModal;
